$(document).ready(function () {
    if ($('#page').attr('data-page-id') === 'org') {
        CKEDITOR.replace('org_note');
        CKEDITOR.replace('org_note_de');

        $('.delete-image').on('click', function () {

            $('.show-image').addClass('d-none');
            $('.show-upload').removeClass('d-none');

            // let path = $('#org_image_path').val();
            // if (path.length > 0) {
            //     axios
            //         .delete('/delete-file/' + path)
            //         .then(function (res) {
            //             console.log(res.data);
            //             $('body').notification({
            //                 type: 'info',
            //                 title: 'Info',
            //                 message: 'The file was successfully deleted.',
            //                 autoClose: 4000
            //             });
            //
            //         }).catch(function (err) {
            //         $('body').notification({
            //             type: 'error',
            //             title: 'Error',
            //             message: 'Unfortunately, an error has occurred, please try again later.',
            //             autoClose: 4000
            //         });
            //     });
            // }

        })
    }
});
